<template>
  <div>
    <div class="hidden lg:flex items-center justify-between">
      <div class="mr-4">{{ $t('pagination_info_text', { from: meta.from, to: meta.to, total: meta.total }) }}</div>

      <div class="flex flex-wrap -mb-1">
        <template v-for="(link, i) in meta.links" :key="'link_' + i">
          <template v-if="link.url === null">
            <div
              class="mr-1 mb-1 px-4 py-3 text-sm leading-4 text-gray-400 shadow opacity-50 bg-white rounded-md cursor-default"
              v-html="link.label"
            />
          </template>
          <template v-else>
            <tec-button
              :href="link.url"
              v-html="link.label"
              :class="link.active ? 'bg-blue-600 border-blue-700 text-white' : 'text-gray-700 bg-white'"
              class="inline-block whitespace-nowrap mr-1 mb-1 px-4 py-3 text-sm leading-4 shadow rounded-md hover:bg-blue-700 hover:text-white hover:border-blue-700 focus:border-blue-600 focus:text-white"
            ></tec-button>
          </template>
        </template>
      </div>
    </div>
    <div class="flex items-center justify-between lg:hidden">
      <tec-button
        :href="links.prev"
        class="inline-block whitespace-nowrap mr-1 mb-1 px-4 py-3 text-sm leading-4 shadow rounded-md"
        :class="
          links.prev
            ? 'text-gray-700 bg-white hover:bg-blue-700 hover:text-white hover:border-blue-700 focus:border-blue-600 focus:text-white'
            : 'text-gray-600 bg-gray-100 cursor-default'
        "
      >
        &laquo; {{ $t('Previous') }}
      </tec-button>
      <div class="mx-3">{{ $t('pagination_info_text', { from: meta.from, to: meta.to, total: meta.total }) }}</div>
      <tec-button
        :href="links.next"
        class="inline-block whitespace-nowrap mr-1 mb-1 px-4 py-3 text-sm leading-4 shadow rounded-md"
        :class="
          links.next
            ? 'text-gray-700 bg-white hover:bg-blue-700 hover:text-white hover:border-blue-700 focus:border-blue-600 focus:text-white'
            : 'text-gray-600 bg-gray-100 cursor-default'
        "
      >
        {{ $t('Next') }} &raquo;
      </tec-button>
    </div>
  </div>
</template>

<script>
import TecButton from '@/Shared/Button';

export default {
  props: ['meta', 'links'],
  components: { TecButton },
};
</script>
